import { useEffect, useState } from 'react';

import type { WithTokenParams } from 'src/app/shared/types';
import type { PaymentType } from 'src/app/shared/utils/payments';

import { usePromoteFormState } from '../../../../formContext';
import { usePaymentTokenFunctions, usePrePaymentChecks, useValidate } from '../../../../shared/hooks';

type Result = {
	inProgress: boolean;
	beforeToken: (paymentType: PaymentType) => Promise<boolean>;
	onTokenError: (paymentType: PaymentType, err: Error) => void;
	onTokenInvalid: (paymentType: PaymentType, err: Error) => void;
	withToken: (params: WithTokenParams) => Promise<void>;
	validate: (paymentType: PaymentType) => Promise<boolean>;
	prePaymentChecks: (paymentType: PaymentType) => Promise<boolean>;
};

export function useSharedHooks(): Result {
	const [{ formState }] = usePromoteFormState();
	const [inProgress, setInProgress] = useState<boolean>(false);
	const { beforeToken, onTokenError, onTokenInvalid, withToken } = usePaymentTokenFunctions();
	const validate = useValidate();
	const prePaymentChecks = usePrePaymentChecks();

	useEffect(() => {
		if (formState.status !== 'loading') {
			// eslint-disable-next-line react-hooks/set-state-in-effect
			setInProgress(false);
		}
	}, [formState]);

	return {
		inProgress,
		beforeToken: async (paymentType: PaymentType) => {
			if (formState.status === 'loading') {
				return Promise.resolve(false);
			}
			setInProgress(true);
			return beforeToken(paymentType);
		},
		onTokenError,
		onTokenInvalid,
		withToken,
		validate,
		prePaymentChecks,
	};
}
